import { AlignSelfType } from 'common/types/styleTypes'
import { justifyContentCss } from 'common/utils/styleUtilsNew'
import styled from 'styled-components'

type BurgerWrapperProps = {
  justifyContent: AlignSelfType
}
const BurgerWrapperUi = styled.div<BurgerWrapperProps>`
  display: flex;
  ${justifyContentCss}
`

export default BurgerWrapperUi
